import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { connect, useDispatch } from "react-redux";
import { get as getProperties } from "../../modules/property/api/actions";
import { get as getPropertyManagers } from "../../modules/propertyManager/api/actions";
import ChipSelector from "../../components/ChipSelector";
import ReportInputs from "../../components/ReportInputs";

const Filter = (props) => {
  const properties = props.properties.data.propertiesList.items;
  const propertyManagers = props.propertyManagers.data.propertyManagersList.items || [];
  const reports = props.settings.reports.items;
  const paymentPlanStatus = props.apl.genericTypes.paymentPlanStatus.data;
  const customerStatus = props.apl.genericTypes.accountStatus.data;

  const disconnectStatus = [
    { value: "Open", description: "Open", uuid: "1" },
    {
      value: "Disconnect Letter Sent",
      description: "Disconnect Letter Sent",
      uuid: "2",
    },
    {
      value: "14 Day Letter Sent",
      description: "14 Day Letter Sent",
      uuid: "3",
    },
    {
      value: "10 Day Letter Sent",
      description: "10 Day Letter Sent",
      uuid: "4",
    },
  ];

  const params = props.params;
  const dispatch = useDispatch();

  // Group reports by their type
  const reportGroups = useMemo(() => {
    const groups = {
      'Financial': [],
      'Customer': [],
      'Property': [],
      'Utility': [],
      'Other': []
    };

    reports.forEach(report => {
      // You can customize this logic based on your report naming convention or add a type field to your reports
      if (report.name.toLowerCase().includes('payment') || report.name.toLowerCase().includes('balance') || report.name.toLowerCase().includes('financial')) {
        groups['Financial'].push(report);
      } else if (report.name.toLowerCase().includes('customer') || report.name.toLowerCase().includes('tenant')) {
        groups['Customer'].push(report);
      } else if (report.name.toLowerCase().includes('property') || report.name.toLowerCase().includes('building')) {
        groups['Property'].push(report);
      } else if (report.name.toLowerCase().includes('utility') || report.name.toLowerCase().includes('usage')) {
        groups['Utility'].push(report);
      } else {
        groups['Other'].push(report);
      }
    });

    // Remove empty groups
    return Object.fromEntries(Object.entries(groups).filter(([_, reports]) => reports.length > 0));
  }, [reports]);

  useEffect(() => {
    if (properties.length == 0) {
      dispatch(getProperties());
    }
    if (propertyManagers.length == 0) {
      dispatch(getPropertyManagers());
    }
  }, [dispatch, properties.length, propertyManagers.length]);

  const handleReportSelect = (report) => {
    props.handleChange({
      target: {
        name: 'report',
        value: report
      }
    });
  };

  return (
    <Box
      component="form"
      sx={{
        width: '100%',
        '& .MuiTextField-root': { 
          width: { xs: '100%', sm: 'auto', md: '300px' }
        },
      }}
      noValidate
      autoComplete="off"
    >
      <div>
        {reports.length > 0 ? (
          <ChipSelector
            groups={reportGroups}
            selectedReport={props.report}
            onSelect={handleReportSelect}
          />
        ) : (
          <CircularProgress />
        )}
      </div>
      <ReportInputs
        filter={props.filter}
        params={props.params}
        properties={properties}
        propertyManagers={propertyManagers}
        paymentPlanStatus={paymentPlanStatus}
        customerStatus={customerStatus}
        disconnectStatus={disconnectStatus}
        handleChange={props.handleChange}
      />
    </Box>
  );
};
// Component Properties
Filter.propTypes = {
  setting: PropTypes.object.isRequired,
  getMessageSettings: PropTypes.func.isRequired,
  getSettings: PropTypes.func.isRequired,
};

// Component State
function FilterState(state) {
  return {
    properties: state.properties,
    propertyManagers: state.propertyManagers,
    settings: state.setting,
    apl: state.apl,
  };
}
export default connect(FilterState, { getProperties, getPropertyManagers })(Filter);
